import { FC } from "react";
import { InfoIcon, LucideIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { I18nKeyType } from "@/i18n";
import { cn } from "@/utils/tailwind";

type InfoCardPropsType = {
  IconComponent?: LucideIcon;
  titleI18nKey: I18nKeyType;
  className?: string;
  titleClassName?: string;
};

export const InfoCard: FC<InfoCardPropsType> = ({
  IconComponent = InfoIcon,
  titleI18nKey,
  className,
  titleClassName,
}) => {
  return (
    <VnBox
      className={cn(
        "bg-secondary border-border flex-row items-start gap-1.5 rounded-md border p-4",
        className,
      )}>
      <VnBox>
        <VnIcon as={IconComponent} className="text-sidebar mt-1" />
      </VnBox>
      <VnText
        variant="lg"
        i18nKey={titleI18nKey}
        className={cn("text-muted-foreground", titleClassName)}
      />
    </VnBox>
  );
};
